import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../i18n';
import classNames from 'classnames';
import Button from '../Button';
import s from './SkipToContent.module.scss';

const SkipToContent = ({ skipTo = '#mainContent' }) => {
    return (
        <Button
            className={s.Root}
            modifier="Secondary"
            tabIndex="0"
            url={skipTo}
            title="Skip to content"
        />
    );
};

SkipToContent.propTypes = {
    skipTo: PropTypes.string.isRequired,
};

export default SkipToContent;
